<template>
  <div class="container">
    <h1>Profil</h1>
      <vendor-name></vendor-name>
    <b-card>
      <vendor-region></vendor-region>
      <text-area-input v-model="details" label="Beschreibung"></text-area-input>
      <text-area-input
          v-model="deliveryInstructions"
          label="Hinweise zur Lieferung"
          desc="Abholadresse und Instruktionen zur Lieferung.">

      </text-area-input>
      <b-button :disabled="inProgress" @click="saveDetails">Speichern
        <b-spinner v-if="inProgress" small></b-spinner>
      </b-button>
    </b-card>

    <vendor-logo></vendor-logo>
    <vendor-image></vendor-image>

    <InvoiceData />
    <h4>Zahlungseinstellungen</h4>
    <b-card>
      <stripe-connect v-model="userProfile.stripeAccount"></stripe-connect>
    </b-card>

  </div>
</template>


<script>

import VendorName from '@/pages/ProfilePage/VendorName'
import VendorLogo from "@/pages/ProfilePage/VendorLogo";
import VendorImage from "@/pages/ProfilePage/VendorImage";
import VendorRegion from "@/pages/ProfilePage/VendorRegion";
import StripeConnect from "@/pages/ProfilePage/StripeConnect";
import InvoiceData from "@/pages/ProfilePage/InvoiceData";
import TextAreaInput from "@/components/TextAreaInput";
import {mapGetters, mapState} from "vuex";

export default {
  inject: ['showSuccessAlert'],
  data(){
    return {
      inProgress: false,
    }
  },
  components: {
    InvoiceData,
    StripeConnect,
    VendorName, VendorLogo, VendorImage, VendorRegion, TextAreaInput
  },
  methods: {
    showToast(message){
      this.$bvToast.toast(message, {
        toaster: 'b-toaster-bottom-right',
        solid: true,
        title: "Status",
        noAutoHide: true,
        appendToast: true
      })
    },
    async saveDetails() {
      this.inProgress = true
      try {
        await this.$store.dispatch('user/saveProfile')
        this.showSuccessAlert("Änderungen gespeichert")
      } catch (error) {
        this.$bvModal.show('error-modal')
      } finally {
        this.inProgress = false
      }
    },
  },
  computed: {
    ...mapState({
        profile: state => state.user.profile,
    }),
    ...mapGetters('user', ['detailsChanged']),
    details: {
      get () {
        return this.profile.details
      },
      set (value) {
        this.$store.commit('user/setProfileUpdate', {details: value})
      }
    },
    deliveryInstructions: {
      get () {
        return this.profile.deliveryInstructions
      },
      set (value) {
        this.$store.commit('user/setProfileUpdate', {deliveryInstructions: value})
      }
    },
    userProfile: {
      get () {
        return this.profile
      },
      set ( value ) {
        console.log(value)
      }
    },
  },
}
</script>
